import { useQuery } from '@tanstack/react-query';
import { chatbotApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface AdminUsageSummaryParams {
  userId?: number;
  from?: Date;
  to?: Date;
  page: number;
  pageSize: number;
}

export function useAdminUsageSummary(params: AdminUsageSummaryParams) {
  return useQuery({
    queryKey: queryKeys.chatAdmin.usage(params),
    queryFn: ({ signal }) =>
      chatbotApiClient.getUsageSummary(
        params.userId,
        params.from,
        params.to,
        params.page,
        params.pageSize,
        toCancelToken(signal),
      ),
    meta: { errorContext: 'chat usage summary' },
  });
}
